import React, { useEffect, useState } from 'react';
import {
    Box,
    Button,
    CircularProgress,
    TextField,
    Typography
} from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import apiUrl from '../../Config';

const AddEditTestimonials = () => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const testimonial = state?.testimonial;
    const [loading, setLoading] = useState(false)

    const [formData, setFormData] = useState({
        name: '',
        designation: '',
        description: '',
        testimonialImg: null,
    });

    useEffect(() => {
        if (testimonial) {
            setFormData({
                name: testimonial.name,
                designation: testimonial.designation,
                description: testimonial.description,
                testimonialImg: testimonial.imageUrl,
            });
        }
    }, [testimonial]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setFormData((prev) => ({
                ...prev,
                testimonialImg: file,
            }));
        }
    };

    const handleSubmit = async () => {
        setLoading(true)
        const data = new FormData();
        data.append('name', formData.name);
        data.append('designation', formData.designation);
        data.append('description', formData.description);
        if (formData.testimonialImg instanceof File) {
            data.append('testimonialImg', formData.testimonialImg);
        }

        try {
            if (testimonial?.id) {
                
                await axios.put(`${apiUrl}/testimonials/updatetestimonial/${testimonial.id}`, data, {
                    headers: { 'Content-Type': 'multipart/form-data' },
                });
            } else {
                data.append('testimonialImg', formData.testimonialImg);
                await axios.post(`${apiUrl}/testimonials/createtestimonial`, data, {
                    headers: { 'Content-Type': 'multipart/form-data' },
                });
            }

            navigate('/display-testimonials');
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false)
        }
    };

    return (
        <Box maxWidth={500} p={{ sm: 2, xs: 2, md: 4, lg: 4 }} mt={0.5}>
            <Typography variant="h5" mb={2}>
                {testimonial ? 'Edit Testimonial' : 'Add Testimonial'}
            </Typography>

            <Box p={2} border={'1px solid lightgrey'}>
                <TextField
                    fullWidth
                    label="Name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                // margin="normal"
                />
                <TextField
                    fullWidth
                    label="Designation"
                    name="designation"
                    value={formData.designation}
                    onChange={handleChange}
                    margin="normal"
                />
                <TextField
                    fullWidth
                    label="Description"
                    name="description"
                    value={formData.description}
                    onChange={handleChange}
                    margin="normal"
                    multiline
                    rows={5}
                />

                <input
                    type="file"
                    accept="image/*"
                    onChange={handleFileChange}
                    style={{ marginTop: '16px' }}
                />

                {formData.testimonialImg && (
                    <Box mt={2}>
                        <img
                            src={
                                formData.testimonialImg instanceof File
                                    ? URL.createObjectURL(formData.testimonialImg)
                                    : formData.testimonialImg
                            }
                            alt="Preview"
                            width="60"
                            height="60"
                            style={{ objectFit: 'cover', borderRadius: '8px' }}
                        />
                    </Box>
                )}

                <Box mt={2} display="flex" justifyContent="right" gap={3}>
                    <Button onClick={() => navigate('/display-testimonials')} variant="outlined" disabled={loading}>
                        Cancel
                    </Button>
                    <Button
                        variant="contained"
                        onClick={handleSubmit}
                        disabled={loading}
                        startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null}
                    >
                        {loading ? (testimonial ? 'Updating...' : 'Creating...') : (testimonial ? 'Update' : 'Create')}
                    </Button>
                </Box>
            </Box>
        </Box>
    );
};

export default AddEditTestimonials;
